<template>
  <div class="zeeman-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>ΔE = g · μB · B · m_j$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Magnets -->
          <rect x="50" y="20" width="300" height="20" fill="#333" />
          <rect x="50" y="200" width="300" height="20" fill="#333" />
          <text x="180" y="35" fill="rgba(255,255,255,0.4)" font-size="10">强磁场区域 B</text>

          <!-- Spectral Line -->
          <g transform="translate(200, 120)">
             <!-- Original Line -->
             <line v-if="bField === 0" x1="0" y1="-60" x2="0" y2="60" stroke="#ffd700" stroke-width="4" />
             
             <!-- Split Lines -->
             <g v-else>
                <line :x1="-bField/2" y1="-60" :x2="-bField/2" y2="60" stroke="#ffd700" stroke-width="2" opacity="0.8" />
                <line x1="0" y1="-60" x2="0" y2="60" stroke="#ffd700" stroke-width="2" />
                <line :x1="bField/2" y1="-60" :x2="bField/2" y2="60" stroke="#ffd700" stroke-width="2" opacity="0.8" />
             </g>
          </g>

          <!-- Label -->
          <text v-if="bField > 0" :x="200 + bField/2 + 10" y="125" fill="#888" font-size="8">谱线劈裂 Δλ ∝ B</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>磁场强度 B: {{ bField }} T</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>调节外磁场 B</label>
             <el-slider v-model="bField" :min="0" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>1896年塞曼发现，当光源置于强磁场中时，原本的一条光谱线会分裂为几条。这是因为在磁场中，原子的**磁矩**具有不同的取向能，导致原有的简并能级发生**劈裂**。这一现象有力地证明了电子具有轨道角动量（以及后来的自旋），是研究原子内部结构和测量恒星磁场的重要手段。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZeemanEffectViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      bField: 0
    }
  }
}
</script>

<style scoped lang="scss">
.zeeman-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
